import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class ClasesService {
  constructor(private api: CloudFunctionsApiService) {}

  getClases() {
    return this.api.snapshotList('/classes');
  }

  getClasesNow() {
    return this.api.getCollection('/classes');
  }

  getClaseById(uid) {
    return this.api.documentChange(`/classes/${uid}`);
  }

  getClaseByIdNow(uid) {
    return this.api.getDocument(`/classes/${uid}`);
  }

  getUserClass(uid) {
    return this.api.snapshotList(`/classes?userId=${encodeURIComponent(uid)}`);
  }

  getUserClassNow(uid) {
    return this.api.getCollection(`/classes?userId=${encodeURIComponent(uid)}`);
  }

  getAdminClassNow(uid) {
    return this.api.getCollection(`/classes?adminId=${encodeURIComponent(uid)}`);
  }

  createdClase(clase) {
    return this.api.post('/classes', clase).toPromise();
  }

  editClase(uid, clase) {
    return this.api.patch(`/classes/${uid}`, clase).toPromise();
  }

  getClaseByCursoid(uid) {
    return this.api.snapshotList(`/classes?courseId=${encodeURIComponent(uid)}`);
  }

  getClaseByCursoidNow(uid) {
    return this.api.getCollection(`/classes?courseId=${encodeURIComponent(uid)}`);
  }

  getClaseByColegio(uid) {
    return this.api.snapshotList(`/classes?schoolId=${encodeURIComponent(uid)}`);
  }

  getClaseByColegioNow(uid) {
    return this.api.getCollection(`/classes?schoolId=${encodeURIComponent(uid)}`);
  }

  DeleteClass(uid) {
    return this.api.delete(`/classes/${uid}`).toPromise();
  }

  addUserToClass(classId, userId) {
    return this.api.post(`/classes/${classId}/users/${userId}`).toPromise();
  }

  removeUserFromClass(classId, userId) {
    return this.api.delete(`/classes/${classId}/users/${userId}`).toPromise();
  }

  addAdminToClass(classId, userId) {
    return this.api.post(`/classes/${classId}/admins/${userId}`).toPromise();
  }

  removeAdminFromClass(classId, userId) {
    return this.api.delete(`/classes/${classId}/admins/${userId}`).toPromise();
  }

  async getClassNames(classIds: string[]): Promise<string[]> {
    const names: string[] = [];
    for (const id of classIds) {
      const classDoc = await this.api.getDocument(`/classes/${id}`).toPromise();
      if (classDoc.exists) {
        names.push(classDoc.data().name || id);
      }
    }
    return names;
  }
}
